// extracted by mini-css-extract-plugin
export default {"column":"classes_column__HQg+3"};